import Modal from 'Components/Modal';
import React, { Component } from 'react';
import axios from 'Axios';
import { Formik } from 'formik';
import { Wizard, Steps, Step } from 'react-albus';
import validationSchema1Step from './formSchema';
import {
  validationSchema1StepArup,
  validationSchema1StepNonArup,
} from './components/Steps/1/formSchema';
import {
  validationSchema2Step,
  validationSchema2StepNonArup,
} from '../RegistrationModal/components/Steps/2/formSchema';

import Step1 from './components/Steps/1';
import Step2 from './components/Steps/2';
import Step3 from './components/Steps/3';
import Step4 from './components/Steps/4';

import { styledTheme } from 'Themes/default';
import { ThemeProvider } from 'styled-components';

const formData = {
  profile: {
    file: '',
    firstName: '',
    lastName: '',
    image: '',
    arupPassword: '',
    usernameArup: '',
    mobile: '',
    regions: [],
    regionName: '',
    regionsArup: [
      {
        name: 'EUROPE',
        id: 'EUROPE',
      },
      {
        name: 'UKIMEA',
        id: 'UKIMEA',
      },
      {
        name: 'EAST ASIA',
        id: 'EAST_ASIA',
      },
      {
        name: 'AUSTRALASIA',
        id: 'AUSTRALASIA',
      },
      {
        name: 'AMERICAS',
        id: 'AMERICAS',
      },
    ],
    regionsCompany: [
      {
        name: 'UK',
        id: 'UK',
      },
      {
        name: 'Europe',
        id: 'EUROPE',
      },
      {
        name: 'Middle East',
        id: 'MIDDLE_EAST',
      },
      {
        name: 'East Asia',
        id: 'EAST_ASIA',
      },
      {
        name: 'India',
        id: 'INDIA',
      },
      {
        name: 'Africa',
        id: 'AFRICA',
      },
      {
        name: 'Australia',
        id: 'AUSTRALIA',
      },
      {
        name: 'South America',
        id: 'SOUTH_AMERICA',
      },
      {
        name: 'North America',
        id: 'NORTH_AMERICA',
      },
      {
        name: 'New Zealand',
        id: 'NEW_ZEALAND',
      },
    ],
    phone: '',
    address: '',
  },
  company: {
    logo: '',
    name: '',
    address: '',
    phone: '',
    website: '',
    registeredCompanyNumber: '',
    companyCity: '',
    companyCountry: '',
    country: '',
  },
  productRange: {
    available: {
      mountingPosition: {
        94: ['Ceiling / Soffit', 1],
        95: ['Wall', 2],
        96: ['Floor (Interior)', 3],
        519: ['Ceiling System', 4],
        97: ['Table', 5],
        98: ['Furniture / Shelf (Interior)', 6],
        527: ['Undercabinet', 7],
        526: ['Trunking / Cable tray / Unistrut', 8],
        520: ['Cove detail', 9],
        522: ['Handrail / Balustrade', 10],
        524: ['Post / Baluster / Stanchion', 11],
        525: ['Structural column / beam / mullion', 12],
        104: ['Ground (Exterior)', 13],
        99: ['Pole / Column / Mast', 14],
        353: ['Façade', 15],
        528: ['Window reveal', 16],
        523: ['Furniture / Bench / Planter (Exterior)', 17],
        521: ['Tree', 18],
        352: ['Cable (catenary)', 19],
        583: ['Other (describe in notes)', 20],
      },
      fittingType: {
        338: ['Accent lighting', 1],
        392: ['Acoustic luminaire', 2],
        339: ['Area lighting', 3],
        393: ['Backlighting', 4],
        58: ['Bollard', 5],
        394: ['Bulkhead', 6],
        582: ['Ceiling (tile / grid / troffer)', 7],
        395: ['Concealed / cove lighting', 8],
        340: ['Decorative', 9],
        341: ['Direct / indirect', 10],
        50: ['Downlight', 11],
        396: ['Festoon', 12],
        397: ['Flexible linear / tape light', 13],
        51: ['Floodlight', 14],
        398: ['Floor-standing luminaire', 15],
        342: ['General Lighting - Direct', 16],
        56: ['Graphic', 17],
        400: ['Grazing light', 18],
        343: ['Heritage / Historic', 19],
        55: ['High bay', 20],
        401: ['In-ground / In-grade luminaire', 21],
        402: ['Integrated lighting (handrail, furniture etc)', 22],
        57: ['Linear', 23],
        403: ['Micro-cell downlight', 24],
        52: ['Modular system', 25],
        404: ['Multiple-head accent lighting', 26],
        405: ['Pendant', 27],
        399: ['Projector (Framing / Gobo)', 28],
        344: ['Road / Street / Path lighting', 29],
        406: ['Spotlight', 30],
        407: ['Step lighting', 31],
        345: ['Task', 32],
        408: ['Tunnel lighting', 33],
        54: ['Uplight', 34],
        409: ['Wall luminaire', 35],
        347: ['Wallwasher', 36],
        410: ['Bespoke / custom luminaire', 37],
        348: ['Emergency lighting', 38],
        411: ['Exit signage', 39],
        412: ['Fibre-optic system', 40],
        349: ['Track system - mains voltage', 41],
        413: ['Track system - low voltage', 42],
        350: ['Pole / column', 43],
        414: ['Driver / transformer / control gear', 44],
        415: ['Enclosure / housing', 45],
        351: ['System component / lighting control', 46],
      },
      mountingType: {
        100: ['Recessed', 1],
        534: ['Recessed - trimless', 2],
        532: ['Semi-recessed', 3],
        101: ['Surface mounted', 4],
        102: ['Pendant / suspended', 5],
        354: ['Floor / ground fixed', 6],
        355: ['Freestanding', 7],
        531: ['Cove / concealed lighting detail', 8],
        359: ['Integrated', 9],
        358: ['Track - low voltage', 10],
        357: ['Track - mains voltage', 11],
        535: ['Track - monopoint / singlet', 12],
        536: ['Pole - bracket-mounted', 13],
        106: ['Pole - integrated', 14],
        107: ['Pole-top', 15],
        537: ['Pole-top - Twin-head', 16],
        538: ['Pole-top - Multi-head', 17],
        533: ['Spike', 18],
        529: ['Bracket / Arm', 19],
        530: ['Clipped', 20],
        108: ['Underwater / Submerged', 21],
        360: ['Catenary', 22],
        361: ['Custom / Bespoke mounting', 23],
      },
    },
    mountingPosition: {
      94: false,
      95: false,
      96: false,
      519: false,
      97: false,
      98: false,
      527: false,
      526: false,
      520: false,
      522: false,
      524: false,
      525: false,
      104: false,
      99: false,
      353: false,
      528: false,
      523: false,
      521: false,
      352: false,
      583: false,
    },
    fittingType: {
      338: false,
      392: false,
      339: false,
      393: false,
      58: false,
      394: false,
      582: false,
      395: false,
      340: false,
      341: false,
      50: false,
      396: false,
      397: false,
      51: false,
      398: false,
      342: false,
      56: false,
      400: false,
      343: false,
      55: false,
      401: false,
      402: false,
      57: false,
      403: false,
      52: false,
      404: false,
      405: false,
      399: false,
      344: false,
      406: false,
      407: false,
      345: false,
      408: false,
      54: false,
      409: false,
      347: false,
      410: false,
      348: false,
      411: false,
      412: false,
      349: false,
      413: false,
      350: false,
      414: false,
      415: false,
      351: false,
    },
    mountingType: {
      100: false,
      534: false,
      532: false,
      101: false,
      102: false,
      354: false,
      355: false,
      531: false,
      359: false,
      358: false,
      357: false,
      535: false,
      536: false,
      106: false,
      107: false,
      537: false,
      538: false,
      533: false,
      529: false,
      530: false,
      108: false,
      360: false,
      361: false,
    },
  },
  countriesWithRegions: {
    EUROPE: [
      'San Marino',
      'Guernsey',
      'Norway',
      'Luxembourg',
      'Sint Maarten',
      'Ukraine',
      'Bosnia and Herzegovina',
      'Cyprus',
      'Vatican City',
      'Caribbean Netherlands',
      'Guadeloupe',
      'Aruba',
      'Albania',
      'Croatia',
      'Latvia',
      'Faroe Islands',
      'Poland',
      'Lithuania',
      'French Guiana',
      'Romania',
      'Svalbard and Jan Mayen',
      'Belarus',
      'Dzechia',
      'Greece',
      'Martinique',
      'France',
      'Serbia',
      'Greenland',
      'Saint Pierre and Miquelon',
      'Hungary',
      'Spain',
      'Ireland',
      'Estonia',
      'Finland',
      'Sweden',
      'Australia',
      'French Southern and Antarctic Lands',
      'Bulgaria',
      'Moldova',
      'Liechtenstein',
      'Slovakia',
      'Mayotte',
      'Italy',
      'New Caledonia',
      'Andora',
      'Malta',
      'Germany',
      'Iceland',
      'Bouvet Island',
      'Aland Islands',
      'Slovenia',
      'Belgium',
      'Portugal',
      'Denmark',
      'Wallis and Futuna',
      'Austria',
      'Monaco',
      'Réunion',
      'Montenegro',
      'Switzerland',
      'French Polynesia',
      'Curaçao',
      'North Macedonia',
      'Netherlands',
    ],
    UKIMEA: [
      'Palestine',
      'Tunisia',
      'South Sudan',
      'Falkland Islands',
      'Central African Republic',
      'Botswana',
      'Bahrain',
      'Nigeria',
      'Pitcairn Islands',
      'Jordan',
      'Turkey',
      'Iraq',
      'South Georgia',
      'Angola',
      'Sierra Leone',
      'Niger',
      'Namibia',
      'Guinea-Bissau',
      'Iran',
      'Togo',
      'Eritrea',
      'Liberia',
      'Somalia',
      'Zambia',
      'United Kingdom',
      'Sudan',
      'Republic of the Congo',
      'Turkmenistan',
      'Azerbaijan',
      'Kenya',
      'Ivory Coast',
      'Senegal',
      'Afghanistan',
      'Kuwait',
      'Ghana',
      'Burkina Faso',
      'Gabon',
      'Zimbabwe',
      'Lesohto',
      'Armenia',
      'Jersey',
      'Ethiopia',
      'Western Sahara',
      'Morocco',
      'Cameroon',
      'Mali',
      'Pakistan',
      'Chad',
      'Comoros',
      'British Virgin Islands',
      'Algeria',
      'Maldives',
      'Cayman Islands',
      'South Africa',
      'British Indian Ocean Territory',
      'Lebanon',
      'Yemen',
      'DR Congo',
      'Oman',
      'Montserrat',
      'Equatorial Guinea',
      'Benin',
      'Isle of Man',
      'Quatar',
      'Rwanda',
      'Cape Verde',
      'Georgia',
      'Burundi',
      'Mauritius',
      'Libya',
      'Malawi',
      'Eswatini',
      'Israel',
      'Uganda',
      'United Arab Emirates',
      'Suriname',
      'Uzbekistan',
      'Saudi Arabia',
      'Egypt',
      'Madagascar',
      'Mauritania',
      'Gambia',
      'Seychelles',
      'Siria',
      'Saint Helena, Ascension and Tristan da Cunha',
      'Tanzania',
      'Anguilla',
      'Mozambique',
      'Turks and Ciacos Islands',
      'Djibouti',
      'Gibraltar',
      'India',
    ],
    'EAST ASIA': [
      'Vietnam',
      'Philippines',
      'Kyrgyzstan',
      'Kazakhstan',
      'Tajikistan',
      'Brunei',
      'Indonesia',
      'Bangladesh',
      'China',
      'Malaysia',
      'Mongolia',
      'Nepal',
      'Taiwan',
      'Bhutan',
      'Cambodia',
      'Rusia',
      'Singapore',
      'Japan',
      'Laos',
      'South Korea',
      'Macau',
      'North Korea',
      'Myanmar',
      'Thailand',
      'Sri Lanka',
    ],
    AUSTRALASIA: [
      'Palau',
      'Timor-Leste',
      'Cook Islands',
      'Christmas Island',
      'Cocos (Keeling) Islands',
      'New Zealand',
      'Niue',
      'Micronesia',
      'Tokelau',
      'Fiji',
      'Vanuatu',
      'Norfolk Island',
      'Tuvalu',
      'Papua New Guinea',
      'Tonga',
      'Nauru',
      'New Caledonia',
      'Marshall Islands',
      'Samoa',
      'Kiribati',
      'Solomon Islands',
      'Heard Islands and McDonald Islands',
    ],
    AMERICAS: [
      'Canada',
      'Cuba',
      'Bazil',
      'Trinidad and Tobago',
      'United States Virgin Islands',
      'Bermuda',
      'Venezuela',
      'American Samoa',
      'El Salvador',
      'Saint Martin',
      'Guatemala',
      'São Tomé and Príncipe',
      'Guam',
      'Grenada',
      'Puerto Rico',
      'Panama',
      'Saint Barthélemy',
      'Peru',
      'Barbados',
      'Colombia',
      'Paraguay',
      'Uruguay',
      'Saint Lucia',
      'United States',
      'Chile',
      'Belize',
      'Guyana',
      'Dominican Republic',
      'Saint Kitts and Nevis',
      'Bolivia',
      'Antigua and Barbuda',
      'Haiti',
      'Bahamas',
      'Mexico',
      'Dominica',
      'Jamaica',
      'Nicaragua',
      'Guinea',
      'United States Minor Outlying Islands',
      'Costa Rica',
      'Argentina',
      'Northern Mariana Islands',
      'Ecuador',
      'Honduras',
      'Saint Vincent and the Grenadines',
      'Brazil',
    ],
  },
};

const steps = [
  {
    id: 'profile',
    component: Step1,
  },
  {
    id: 'company',
    component: Step2,
  },
  {
    id: 'productRange',
    component: Step3,
  },
  {
    id: 'confirmation',
    component: Step4,
  },
];

class RegistrationModal extends Component {
  state = {
    validationSchema: validationSchema1Step,
    countries: [],
  };

  changeFormSchema = revalidate => {
    const isNonArupRegistration =
      this.props.registrationData.type === 'NON_ARUP_REGISTRATION';

    const typeOfUserValidation = isNonArupRegistration
      ? validationSchema2StepNonArup
      : validationSchema2Step;

    this.setState({ validationSchema: typeOfUserValidation }, revalidate);
  };

  // rest api for all countries for non arup demand users in company info step
  fetchCountries = async () => {
    try {
      const response = await axios('https://restcountries.com/v3.1/all');

      if (response.status === 200) {
        const mappedData = response.data.map(country => country.name.common);
        this.setState({ countries: mappedData });
      } else {
        throw new Error(`Error fetching countries: ${response.statusText}`);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  componentDidMount() {
    this.fetchCountries();

    if (this.props.registrationData.type === 'ARUP_REGISTRATION') {
      this.setState({ validationSchema: validationSchema1StepArup });
    } else if (this.props.registrationData.type === 'NON_ARUP_REGISTRATION') {
      this.setState({ validationSchema: validationSchema1StepNonArup });
    }
  }

  render() {
    const { acctok, registrationData } = this.props;
    return (
      <ThemeProvider theme={styledTheme}>
        <Modal open={this.props.open}>
          <Formik
            initialValues={formData}
            onSubmit={(values, actions) => {}}
            validationSchema={this.state.validationSchema}
            validateOnBlur
            enableReinitialize
          >
            {props => (
              <Wizard>
                <Steps>
                  {steps.map(({ id, component: StepComponent }) => {
                    return (
                      <Step
                        id={id}
                        key={id}
                        render={({ next, previous, step }) => (
                          <StepComponent
                            next={next}
                            previous={previous}
                            step={step}
                            handleModalClose={this.props.handleModal}
                            acctok={acctok}
                            registrationData={registrationData}
                            changeFormSchema={this.changeFormSchema}
                            countries={this.state.countries}
                            {...props}
                          ></StepComponent>
                        )}
                      />
                    );
                  })}
                </Steps>
              </Wizard>
            )}
          </Formik>
        </Modal>
      </ThemeProvider>
    );
  }
}

export default RegistrationModal;
